import own from "./FingerHint.module.css";

/**
 * The expected key on a pulsing badge, next to the finger that reaches it.
 *
 * `modifier` kommt dazu, wo die Lektion einen Weg vorschreibt – „+ Feststelltaste“
 * oder „+ rechte Umschalttaste“. Vorher trug der Fingername das selbst; in
 * Lektion 10 nannte er damit die Umschalttaste, die dort ein Vertipper ist.
 */
export function FingerHint({
  expected,
  fingerName,
  modifier,
}: {
  expected: string | null;
  fingerName: string | null;
  modifier: string | null;
}) {
  return (
    <div className={own.fingerRow}>
      {expected !== null && fingerName && (
        <>
          <span className={`${own.fingerBadge} pulse`}>
            {expected === " " ? "␣" : expected}
          </span>
          <span className={own.fingerName}>
            {modifier ? `${fingerName} + ${modifier}` : fingerName}
          </span>
        </>
      )}
    </div>
  );
}
